import { api } from './client';
import type { Envelope } from './types';

export interface Invitation {
  id: string;
  meetingId: string;
  token: string;
  shareUrl: string;
  expiresAt: string;
  status: string;
  createdAt: string;
}

export interface InvitationPublic {
  meetingId: string;
  meetingTitle: string;
  meetingRegion: string | null;
  confirmedDate: string | null;
  meetingPointName: string | null;
  meetingStatus: string;
  participantCount: number;
  hostNickname: string;
  status: string;
  expiresAt: string;
}

export async function createInvitation(meetingId: string) {
  const { data } = await api.post<Envelope<Invitation>>(`/meetings/${meetingId}/invitations`);
  return data.data;
}

export async function getInvitationPublic(token: string) {
  const { data } = await api.get<Envelope<InvitationPublic>>(`/invitations/${token}`);
  return data.data;
}

export async function acceptInvitation(token: string) {
  const { data } = await api.post<
    Envelope<{ meetingId: string; participantId: string; alreadyJoined: boolean }>
  >(`/invitations/${token}/accept`);
  return data.data;
}
